/**
 * Procedures Services Module
 * Exports all Procedures Management services, the presigned upload helper and the factory function.
 * Backend: CCMS.Api.ProceduresManagement (servicePath `procedures`, gateway prefix `/procedures/`).
 */
import { PublicProceduresService } from './PublicProceduresService';
import { ProceduresMemberService } from './ProceduresMemberService';
import { ProceduresAdminService } from './ProceduresAdminService';
export { PublicProceduresService, ProceduresMemberService, ProceduresAdminService };
export { uploadToPresignedUrl } from './uploadToPresignedUrl';
/**
 * Create all Procedures Management services with shared configuration.
 */
export function createProceduresServices(http, config) {
    return {
        publicProcedures: new PublicProceduresService(http, config),
        proceduresMember: new ProceduresMemberService(http, config),
        proceduresAdmin: new ProceduresAdminService(http, config),
    };
}
//# sourceMappingURL=index.js.map